module.exports = __webpack_public_path__ + "img/magnifier.a27dfa07.svg";